module.exports = __webpack_public_path__ + "img/manageprofile.1429e073.svg";